//js
import React from 'react';
import ReactDOM from 'react-dom';
// import { Router } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { useStore } from 'store';
import { StateProvider, DispatchProvider } from 'context';
//import { createBrowserHistory } from "history";
import CONFIG from "config";
//css
import 'styles/fonts.css';
import 'styles/index.css';
// import 'styles/animate.css';
import 'styles/w3.css';
import 'styles/w3-theme.css';
import 'styles/style.css';
import 'styles/colors.css';
import 'animate.css';
//main component
import App from 'app/app';
import reportWebVitals from './reportWebVitals';

//const history = createBrowserHistory();
function Root() {
  const { state, dispatch } = useStore();
  return (
    <DispatchProvider value={dispatch}>
      <StateProvider value={state}>
        <App />
      </StateProvider>
    </DispatchProvider>
  );
}
ReactDOM.render(
  <React.StrictMode>
    <Router basename={CONFIG.BASENAME} >
      <Root />
    </Router>
  </React.StrictMode>,
  document.getElementById('root'));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();